<template>
  <div class="teaching-score-confirm-detail-main"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="scheduleDetail">
      <div class="header">
        <div class="prepend"></div>
        <div class="append">
          <el-input v-model.trim="input.keyword"
                    size="mini"
                    type="text"
                    clearable
                    placeholder="搜索学生学号/姓名"
                    @clear="handleFilter"
                    @keyup.enter.native="handleFilter">
            <template #append>
              <el-button size="mini"
                         type="primary"
                         @click="handleFilter">搜索</el-button>
            </template>
          </el-input>
        </div>
      </div>
      <div class="body">
        <div class="body-cont">
          <DataGrid ref="grid"
                    size="mini"
                    height="auto"
                    border="inner">
            <DataGridColumn type="seq"
                            title="序号"
                            width="80"
                            align="center"></DataGridColumn>
            <DataGridColumn title="班级"
                            field="clazz"
                            min-width="100"
                            align="center"
                            sortable></DataGridColumn>
            <DataGridColumn title="学号"
                            field="regNo"
                            min-width="100"
                            align="center"
                            sortable></DataGridColumn>
            <DataGridColumn title="姓名"
                            field="trueName"
                            min-width="100"
                            align="center"
                            sortable>
              <template #default="{row}">
                  <span class="value">
                    <span v-if="row.isSupply"
                          class="is-star"
                          title="补修"></span>
                    <span>{{row.trueName}}</span>
                  </span>
              </template>
            </DataGridColumn>
            <DataGridColumn title="是否初修"
                            field="isFirst"
                            min-width="80"
                            align="center"
                            sortable>
              <template #default="{row}">
                <span>{{row.isFirst ? '是' : '否'}}</span>
              </template>
            </DataGridColumn>
            <DataGridColumn v-if="scheduleDetail.usualScoreScale"
                            field="scoreUsualZh"
                            min-width="100"
                            align="center"
                            sortable>
              <template #header>
                <TeachingScoreConfirmTitle label="平时成绩"
                                           :scale="scheduleDetail.usualScoreScale"></TeachingScoreConfirmTitle>
              </template>
              <template #default="{row}">
                <TeachingScoreConfirmValue :score-rule="getScoreRule"
                                           :value="row.scoreUsualLuru"
                                           :digit="row.scoreUsualZh"></TeachingScoreConfirmValue>
              </template>
            </DataGridColumn>
            <DataGridColumn v-if="scheduleDetail.examScoreScale"
                            field="scoreExamZh"
                            min-width="100"
                            align="center"
                            sortable>
              <template #header>
                <TeachingScoreConfirmTitle label="考试成绩"
                                           :scale="scheduleDetail.examScoreScale"></TeachingScoreConfirmTitle>
              </template>
              <template #default="{row}">
                <TeachingScoreConfirmValue :score-rule="getScoreRule"
                                           :value="row.scoreExamLuru"
                                           :digit="row.scoreExamZh"></TeachingScoreConfirmValue>
              </template>
            </DataGridColumn>
            <DataGridColumn v-if="scheduleDetail.workScoreScale"
                            field="scoreWorkZh"
                            min-width="100"
                            align="center"
                            sortable>
              <template #header>
                <TeachingScoreConfirmTitle label="作业成绩"
                                           :scale="scheduleDetail.workScoreScale"></TeachingScoreConfirmTitle>
              </template>
              <template #default="{row}">
                <TeachingScoreConfirmValue :score-rule="getScoreRule"
                                           :value="row.scoreWorkLuru"
                                           :digit="row.scoreWorkZh"></TeachingScoreConfirmValue>
              </template>
            </DataGridColumn>
            <DataGridColumn v-if="scheduleDetail.reportScoreScale"
                            field="scoreReportZh"
                            min-width="100"
                            align="center"
                            sortable>
              <template #header>
                <TeachingScoreConfirmTitle label="实践报告成绩"
                                           :scale="scheduleDetail.reportScoreScale"></TeachingScoreConfirmTitle>
              </template>
              <template #default="{row}">
                <TeachingScoreConfirmValue :score-rule="getScoreRule"
                                           :value="row.scoreReportLuru"
                                           :digit="row.scoreReportZh"></TeachingScoreConfirmValue>
              </template>
            </DataGridColumn>
            <DataGridColumn v-if="scheduleDetail.caseScoreScale"
                            field="scoreCaseZh"
                            min-width="100"
                            align="center"
                            sortable>
              <template #header>
                <TeachingScoreConfirmTitle label="案例分析成绩"
                                           :scale="scheduleDetail.caseScoreScale"></TeachingScoreConfirmTitle>
              </template>
              <template #default="{row}">
                <TeachingScoreConfirmValue :score-rule="getScoreRule"
                                           :value="row.scoreCaseLuru"
                                           :digit="row.scoreCaseZh"></TeachingScoreConfirmValue>
              </template>
            </DataGridColumn>
            <DataGridColumn title="综合成绩"
                            field="scoreMergeZh"
                            min-width="100"
                            align="center"
                            sortable>
              <template #default="{row}">
                <TeachingScoreConfirmValue :score-rule="getScoreRule"
                                           :value="row.scoreMergeLuru"
                                           :digit="row.scoreMergeZh"></TeachingScoreConfirmValue>
              </template>
            </DataGridColumn>
          </DataGrid>
        </div>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>课程成绩加载失败</div>
        <el-button type="text"
                   @click="loadScheduleDetail">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import DataGrid from '../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../elements/DataGridColumn'
import TeachingScoreConfirmTitle from '../widget/title'
import TeachingScoreConfirmValue from '../widget/value'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'TeachingScoreConfirmDetailMain',
  inject: {
    $popper: {
      default: null
    }
  },
  components: {
    DataGrid,
    DataGridColumn,
    TeachingScoreConfirmTitle,
    TeachingScoreConfirmValue,
    Hint
  },
  props: {
    scheduleId: {
      type: String,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      scheduleDetail: null,
      input: {
        keyword: ''
      },
      check: {
        keyword: ''
      }
    }
  },
  computed: {
    getScoreRule () {
      const scheduleDetail = this.scheduleDetail
      if (scheduleDetail) {
        return {
          usualScoreScale: scheduleDetail.usualScoreScale,
          examScoreScale: scheduleDetail.examScoreScale,
          workScoreScale: scheduleDetail.workScoreScale,
          reportScoreScale: scheduleDetail.reportScoreScale,
          caseScoreScale: scheduleDetail.caseScoreScale,
          minScore: scheduleDetail.minScore,
          maxScore: scheduleDetail.maxScore,
          passScore: scheduleDetail.passScore
        }
      }
    },
    getRecords () {
      const scheduleDetail = this.scheduleDetail
      if (scheduleDetail) {
        let records = scheduleDetail.records || []
        let keyword = this.check.keyword
        if (keyword) {
          records = records.filter(record => {
            return (record.regNo || '').includes(keyword) || (record.trueName || '').includes(keyword)
          })
        }
        return records
      }
    }
  },
  methods: {
    handleFilter () {
      Object.keys(this.input).forEach(key => {
        this.check[key] = this.input[key]
      })
    },
    filterResult () {
      const grid = this.$refs.grid
      if (grid) {
        grid.loadData(this.getRecords)
      }
    },
    loadScheduleDetail () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/score/confirm/schedule/detail',
        method: 'post',
        data: this.$qs.stringify({
          scheduleId: this.scheduleId
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.scheduleDetail = response.data['scheduleDetail'] || {}
              this.$nextTick(() => {
                this.filterResult()
                this.$emit('ready')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    initialScoreRecord () {
      const grid = this.$refs.grid
      if (grid) {
        grid.loadData(null)
      }
    },
    bindPopperEvent () {
      if (this.$popper) {
        this.$popper.$on('closed', this.initialScoreRecord)
      }
    },
    unbindPopperEvent () {
      if (this.$popper) {
        this.$popper.$off('closed', this.initialScoreRecord)
      }
    }
  },
  created () {
    this.bindPopperEvent()
  },
  mounted () {
    this.loadScheduleDetail()
  },
  beforeDestroy () {
    this.unbindPopperEvent()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadScheduleDetail()
      }
    },
    check: {
      handler () {
        this.$nextTick(() => this.filterResult())
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../../styles/color";
  .teaching-score-confirm-detail-main {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      display: flex;
      align-items: center;
      & > .prepend {
        flex: auto;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 7px 8px;
        .el-button {
          margin: 5px 6px;
          padding: 6px 15px 6px 10px;
          i {
            font-size: 14px;
            vertical-align: -1px;
          }
        }
      }
      & > .append {
        margin-left: 15px;
        padding: 10px 15px 10px 0;
        .el-input {
          width: 220px;
          .el-input__inner {
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
          }
          .el-input-group__append {
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
            padding-left: 15px;
            padding-right: 15px;
          }
        }
      }
    }
    & > .body {
      flex: auto;
      position: relative;
      & > .body-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .vxe-table {
          .vxe-table--header-wrapper {
            .vxe-table--header {
              .vxe-header--row {
                background-color: #f9f9fa;
                .vxe-header--column {
                  height: 46px;
                  line-height: 18px;
                  padding: 0;
                  .vxe-cell {
                    padding: 0;
                  }
                }
              }
            }
          }
          .vxe-table--body-wrapper {
            .vxe-table--body {
              .vxe-body--row {
                .vxe-body--column {
                  height: 46px;
                  padding: 0;
                  .vxe-cell {
                    .value {
                      & > .is-star {
                        position: relative;
                        cursor: pointer;
                        &:before {
                          content: '\2605';
                          position: absolute;
                          left: -14px;
                          color: $set-danger-color;
                        }
                      }
                      &.is-fail {
                        color: $set-danger-color;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
